module.exports = __webpack_public_path__ + "static/media/ios-sunny.4cd31fa4.svg";